import React, { useCallback, useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { base, LabelContainer, Label, Info } from './style'

function InputText({label, required, maxLength, onChange, model, ...rest}) {
    const [error, setError] = useState(false) 
    const [count, setCount] = useState(rest.value ? rest.value.length : 0) 
    const validate = useCallback((e) => {
        if(e.target.value === "") {
            setError(true)
        } else {
            setError(false)
        }
    }, [])

    const change = useCallback(e => {
        if(maxLength) {
            setCount(e.target.value.length)
        }
        
        if(onChange) {
            onChange(e)
        }

        if(model) {
            model.onChange(e)
        }
    })

    useEffect(() => {
        if(!model) return

        model.ref.current = {
            error: () => {
                setError(true)
            }
        }
    }, [])

    return (
        <LabelContainer>
            <Label>{label}</Label>
            <Textarea
                error={error} 
                onBlur={required && validate}
                onKeyUp={error ? validate : null}
                maxLength={maxLength}
                onChange={change}
                value={model ? model.value : undefined}
                name={model ? model.name : ""}
                {...rest}
            />
            {maxLength && (
                <Info>{count}/{maxLength}</Info>
            )}
        </LabelContainer>
    )
}

const Textarea = styled.textarea`
    ${base}
    ${props => props.error && css`
        border: 1px solid #FF0000;
    `}
    resize: none;
`

export default InputText


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Form/Textarea.js